import * as Sentry from '@sentry/nextjs';
import 'client-only';

import { mirrorOnRootSpan } from '../utils/mirror-on-root-span';

const AUTHED_FETCH_ATTR = {
  OUTCOME: 'authed_fetch.outcome',
  ROUTE_GROUP: 'authed_fetch.route_group',
} as const;

export type AuthedFetchOutcome =
  | 'attached'
  | 'skipped_no_session'
  | 'skipped_not_allowlisted'
  | 'skipped_null_token';

/** First `/api/` segment only — no deal or flow UUIDs in tags. */
export function routeGroupOf(pathname: string): string | undefined {
  return pathname.split('/')[2] || undefined;
}

/**
 * Records `authed_fetch.outcome` (and route group when known) on the active
 * root span. No-ops when there is no active span — never creates one.
 */
export function observeAuthedFetch(
  outcome: AuthedFetchOutcome,
  pathname?: string
): void {
  try {
    const active = Sentry.getActiveSpan();
    if (!active) return;

    const attrs: Record<string, string> = {
      [AUTHED_FETCH_ATTR.OUTCOME]: outcome,
    };

    if (pathname) {
      const routeGroup = routeGroupOf(pathname);
      if (routeGroup) {
        attrs[AUTHED_FETCH_ATTR.ROUTE_GROUP] = routeGroup;
      }
    }

    mirrorOnRootSpan(attrs);
  } catch {
    // Observability must not interrupt the fetch it observes.
  }
}
